/**
 * @generated SignedSource<<8f2332ce3934a44e7e2ed8297c6d62bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getClickCardDataPropertyMappingSetsByIdsQuery$variables = {
  property_id: number;
};
export type getClickCardDataPropertyMappingSetsByIdsQuery$data = {
  readonly sys_properties_mapping_sets: ReadonlyArray<{
    readonly mapping_set: {
      readonly mapping_set_description: string;
    };
  }>;
};
export type getClickCardDataPropertyMappingSetsByIdsQuery = {
  response: getClickCardDataPropertyMappingSetsByIdsQuery$data;
  variables: getClickCardDataPropertyMappingSetsByIdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "property_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "is_active",
            "value": {
              "_eq": true
            }
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "property_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "property_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_properties_mapping_sets",
    "kind": "LinkedField",
    "name": "sys_properties_mapping_sets",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_mapping_sets",
        "kind": "LinkedField",
        "name": "mapping_set",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mapping_set_description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getClickCardDataPropertyMappingSetsByIdsQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getClickCardDataPropertyMappingSetsByIdsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4392cce94421addc8fb5593281964c31",
    "id": null,
    "metadata": {},
    "name": "getClickCardDataPropertyMappingSetsByIdsQuery",
    "operationKind": "query",
    "text": "query getClickCardDataPropertyMappingSetsByIdsQuery(\n  $property_id: Int!\n) {\n  sys_properties_mapping_sets(where: {property_id: {_eq: $property_id}, is_active: {_eq: true}}) {\n    mapping_set {\n      mapping_set_description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "91aca303ec8feffdb546992c96dbc32a";

export default node;
